import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue"
import { useQuery } from "@vue/apollo-composable"
import {
  MissionContractPayment,
  MyClientQuery,
  MyClientQueryQuery,
  UnreadConversationsQuery,
} from "@/gql"
import { PageState } from "@/types"
import { useAccountContext } from "@/hooks/useAccountContext"
import UserAvatarGroup from "@/components/widgets/common/UserAvatarGroup.vue"
import AppPage from "@/components/layout/AppPage.vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import InlineTaskCard from "@/components/client/Dashboard/InlineTaskCard.vue"
import MissionUpdates from "@/modules/Missions/components/MissionUpdates/MissionUpdates.vue"
import PendingPaymentCard from "@/components/client/Dashboard/PendingPaymentCard.vue"
import UnreadMessages from "@/components/client/Dashboard/UnreadMessages.vue"
import CreateNewProject from "@/modules/Missions/CreateNewProject/CreateNewProject.vue"
import { useAuth } from "@/store/auth/useAuth"
import useRouter from "@/router/useRouter"


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientDashboard',
  setup(__props) {

const client = ref<MyClientQueryQuery["myClient"]>(null)
const pageState = ref(PageState.Loaded)
const loadingClientDetails = ref(true)
const loadingError = ref(false)
const networkError = ref(false)
const openCreateProject = ref(false)
const unreadConversations = ref([])

const { routes } = useRouter()

const { client: accountClient } = useAccountContext()
const clientId = accountClient?.prn

const { result: clientResult, error: clientError } = useQuery(MyClientQuery, () => ({
  id: clientId,
}))

const { result: unreadConversationsResult, error: unreadConversationsError } = useQuery(
  UnreadConversationsQuery,
  () => ({
    clientId,
  })
)

watch(
  clientResult,
  (newResult) => {
    if (newResult) {
      client.value = newResult.myClient
      loadingClientDetails.value = false
      pageState.value = PageState.Loaded
    }
  },
  {
    immediate: true,
  }
)

watch(unreadConversationsResult, (newResult) => {
  if (newResult) {
    unreadConversations.value = newResult.unreadConversations || []
  }
})

watch([clientError, unreadConversationsError], ([newClientError, newUnreadConversationsError]) => {
  if (newClientError?.graphQLErrors || newUnreadConversationsError?.graphQLErrors) {
    loadingClientDetails.value = false
    loadingError.value = true
    pageState.value = PageState.Error
  } else if (newClientError?.networkError || newUnreadConversationsError?.networkError) {
    networkError.value = true
  }
})

const priorityPayment = computed<MissionContractPayment | null>(
  () => (client.value?.priorityPayments?.[0] as MissionContractPayment) ?? null
)

const { user } = useAuth()

return { __sfc: true,client, pageState, loadingClientDetails, loadingError, networkError, openCreateProject, unreadConversations, routes, accountClient, clientId, clientResult, clientError, unreadConversationsResult, unreadConversationsError, priorityPayment, user, UserAvatarGroup, AppPage, Icon, InlineTaskCard, MissionUpdates, PendingPaymentCard, UnreadMessages, CreateNewProject }
}

})